import ScheduleStatusApp from "./ScheduleStatusApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(ScheduleStatusApp);
